import React from "react";
import { Route } from "react-router-dom";

import { appRouteConfig } from "./app-route-config";
import ProtectedRoute from "./protected-route";

export const routeArray = appRouteConfig;

const generatePrivateRoutes = routes =>
  routes.map(({ path, roles: routeRoles, component }) => (
    <Route
      key={path}
      path={path}
      element={<ProtectedRoute roles={routeRoles} component={component} />}
    />
  ));

export default generatePrivateRoutes;
